export default "<app-section1></app-section1>\r\n<app-section2></app-section2>\r\n"